export const IMPORTED_RESOURCES_ATTR = 'data-say-imported-resources';
